// extracted by mini-css-extract-plugin
export default {"container":"WbKjGQDhq8oB7X_wHgZoU"};